import GetCryptoKey from './get-crypto-key-old';
const cryptoJs = require('crypto-js');

const cryptoKey = await GetCryptoKey();

export default function Decrypt(data) {
    return cryptoJs.AES.decrypt(data, cryptoKey).toString(cryptoJs.enc.Utf8);
}
